/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PileTurnerPalletList } from '../../models/pile-turner-pallet-list';

export interface GetPalletList$Params {
  workCenterId: number;
}

export function getPalletList(http: HttpClient, rootUrl: string, params: GetPalletList$Params, context?: HttpContext): Observable<StrictHttpResponse<PileTurnerPalletList>> {
  const rb = new RequestBuilder(rootUrl, getPalletList.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PileTurnerPalletList>;
    })
  );
}

getPalletList.PATH = '/api/v1/PileTurner/{workCenterId}/PalletList';
